import type { MatchupReport } from "@averagejoesff/shared";
import { fetchMatchupIndex, fetchMatchupReport } from "../../api/awards";
import { useResource } from "../../lib/useResource";

/**
 * The latest published Matchups report, if it is for this very week. Optional
 * extra: while it loads, fails or is absent this is null, and Home shows its
 * history-only versions (and doesn't link games to a report that isn't there).
 */
export function useCurrentReport(season: number | null, week: number | null): MatchupReport | null {
  const [resource] = useResource(async () => {
    if (season === null || week === null) return null;
    const latest = (await fetchMatchupIndex())?.reports[0];
    return latest && latest.season === season && latest.week === week ? fetchMatchupReport(season, week) : null;
  }, [season, week]);
  return resource.status === "ready" ? resource.data : null;
}
